import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import {
  createLocatorAsync,
  clearMessages,
  selectCreateLoading,
  selectCreateError,
  selectCreateSuccessMsg,
} from '../../redux/locatorManagement/createLocatorSlice';
import { getMarketsAsync, selectMarkets } from '../../redux/markets/getMarketsSlice';
import { listLocatorPages } from '../../services/locatorManagementService';

export default function useCreateLocator(onSuccess) {
  const dispatch = useDispatch();
  const form = useForm({
    defaultValues: {
      market_id: '',
      platform: '',
      build: '',
      page: '',
      locator_name: '',
      locator_type: '',
      locator_value: '',
    },
  });
  const [open, setOpen] = useState(false);
  const [pages, setPages] = useState([]);
  const markets = useSelector(selectMarkets);

  useEffect(() => {
    dispatch(getMarketsAsync());
    listLocatorPages()
      .then(setPages)
      .catch(() => {});
  }, [dispatch]);

  const loading = useSelector(selectCreateLoading);
  const error = useSelector(selectCreateError);
  const successMsg = useSelector(selectCreateSuccessMsg);

  useEffect(() => {
    if (!successMsg) return;
    const timer = setTimeout(() => dispatch(clearMessages()), 3000);
    return () => clearTimeout(timer);
  }, [successMsg, dispatch]);

  const handleOpen = () => {
    form.reset();
    dispatch(clearMessages());
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    form.reset();
    dispatch(clearMessages());
  };

  const handleSave = form.handleSubmit(async (data) => {
    try {
      await dispatch(
        createLocatorAsync({
          _isClone: false,
          market_id: Number(data.market_id),
          platform: data.platform,
          build: Number(data.build),
          page: data.page,
          locator_name: data.locator_name,
          locator_type: data.locator_type,
          locator_value: data.locator_value,
        }),
      ).unwrap();
      setOpen(false);
      onSuccess?.();
    } catch {
      // error shown via Redux state
    }
  });

  return {
    form,
    open,
    pages,
    markets,
    loading,
    error,
    successMsg,
    handleOpen,
    handleClose,
    handleSave,
    clearMessages: () => dispatch(clearMessages()),
  };
}
